import {Box, CardMedia, Dialog, Grid, Typography} from "@mui/material";
import React, {useState} from "react";

import {useLanguage} from "../../../LanguageContext";
import {imageBoxStyle, imageGridContainerStyle, textStyle, title} from "../../styles/TabStyles";
import {tabContent} from "./CommonTab";
import FullScreenTab from "./FullScreenTab";


const ImageDialog = ({open, handleClose, image}) => (
    <Dialog open={open}
            onClose={handleClose}
            sx={{
                width: "100vw", // Full viewport width
                height: "100vh", // Full viewport height
                margin: 0,
                padding: 0,
                ".MuiPaper-root": {
                    // width: "100vw",
                    height: "100vh",
                    margin: 0,
                    padding: 0,
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                },
            }}
            PaperProps={{style: {backgroundColor: "transparent", boxShadow: "none"}}}
            maxWidth="md" fullWidth>
        <Box
            sx={{
                maxWidth: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden", // Prevent scrolling issues
            }}
            onClick={handleClose}>
            <CardMedia
                component="img"
                image={image}
                sx={{
                    maxHeight: "100vw",
                    maxWidth: "100vw",
                    objectFit: "contain"
                }}
            />
        </Box>
    </Dialog>
);


const AccommodationTab = ({content}) => {
    const {t} = useLanguage();

    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageClick = (image) => {
        setSelectedImage(image);
    };

    const handleClose = () => {
        setSelectedImage(null);
    };

    return (
        <FullScreenTab>
            <Box sx={{
                ...tabContent,
            }}>
                <Box
                    sx={{
                        p: 3,
                        textAlign: 'center',
                    }}
                >
                    <Typography sx={title}>
                        {t('label_hotel_title').toUpperCase()}
                    </Typography>

                    <Box
                        sx={{
                            width: {
                                xs: '100%',
                                sm: '90%',
                                md: '80%',
                                lg: '80%',
                            },
                            marginLeft: {
                                sx: '0%',
                                sm: '5%',
                                md: '10%',
                                lg: '10%',
                            },
                        }}>
                        {t(content.descriptions).map((item, index) => (
                            <Box
                                key={index}
                                sx={{paddingBottom: '10px'}}>
                                <Typography
                                    key={index}
                                    sx={textStyle}>
                                    {item}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>


            {/* Responsive Grid of Pictures */}
            <Grid
                container
                spacing={2}
                sx={imageGridContainerStyle}
            >
                {content.images.map((image, index) => (
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        md={3}
                        lg={1.5}
                        key={index}
                    >
                        <Box
                            onClick={() => handleImageClick(image)}
                            component="img"
                            src={image}
                            alt={`Gallery ${index + 1}`}
                            sx={imageBoxStyle}
                        />
                    </Grid>
                ))}
                <ImageDialog open={!!selectedImage} handleClose={handleClose} image={selectedImage}/>
            </Grid>

        </FullScreenTab>
    );
};

export default AccommodationTab;
